/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:42 2018/11/13
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { default as AgGridVueCustomTsx, ColDefCustom } from '../../../components/agGridCustom/agGridVueCustomTsx';
import { createBEM, createNamespace } from 'src/util/bem';
import './stationSetting.less';
import Bus, { Events } from 'src/util/bus';
import StationListApi, { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import { GridOptions } from 'ag-grid-community';
import NumberRender from 'src/components/agGridComponent/NumberRender';
import StringRender from 'src/components/agGridComponent/StringRender';
import { Integer } from 'src/types/base';
import Input from 'src/types/iview/Input';
import StationDetailApi, { StationDetailDOI } from '../api/stationDetailApi';
import Button from 'src/types/iview/Button';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import { Toast } from 'src/util/toast';
import { type } from 'os';
import InputNumber from 'src/types/iview/InputNumber';
let bem = createBEM('station-setting');

export namespace StationSettingVOI{
    export interface FormDataI{
        people: string,
        contact: string,
        userIds: Integer[],
        newOpsTime: string,
        opsName: string,
        opsCause: string,
        opsPeriod: Integer,
        timeRemaining: string,
        refresh_cycle: Integer
    }
}

@Component({
    name: 'station-setting',
})
export default class StationSetting extends Vue.Component<any> {
    id: number = -1;
    mn: string = '';

    // 附件相关的表格
    gridOptions: GridOptions = {};

    columnDefs: ColDefCustom[] = [
        {
            headerName: '设备信息',
            field: 'component_name',
            minWidth: 130
        },
        // {
        //     headerName: '设备信息',
        //     field: 'device_info',
        //     minWidth: 160,
        //     cellRendererFramework: StringRender,
        //     cellRendererFrameworkOpt: {
        //         editable: true,
        //         precision: 2
        //     }
        // },
        {
            headerName: '厂家名称',
            field: 'manufacturer_name',
            minWidth: 160,
            cellRendererFramework: StringRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '型号',
            field: 'type',
            minWidth: 160,
            cellRendererFramework: StringRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '设备编号',
            field: 'device_code',
            minWidth: 160,
            cellRendererFramework: StringRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '量程',
            field: 'range_s',
            minWidth: 160,
            cellRendererFramework: StringRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },
         {
            headerName: '报警下限',
            field: 'alarm_ceiling',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '报警上限',
            field: 'alarm_floor',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '标样核查百分比(%)',
            field: 'check_standard',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '跨度核查百分比(%)',
            field: 'check_span',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        },{
            headerName: '零样核查百分比(%)',
            field: 'check_zero',
            minWidth: 160,
            cellRendererFramework: NumberRender,
            cellRendererFrameworkOpt: {
                editable: true,
                precision: 2
            }
        }
    ];
    get currentStation(): StationListDOI.RowDataI {
        return this.$store.state.stationDetail.currentStation;
    }
    rowData: StationDetailDOI.StationWarnSettingsI[] = [];

    formData: StationSettingVOI.FormDataI = {
        people: '',
        contact: '',
        userIds: [],
        newOpsTime: '',
        opsName: '',
        opsCause: '',
        opsPeriod: 0,
        timeRemaining: '',
        refresh_cycle: 1,
    }
    loading:boolean = false
    isShowOpsInfo:boolean = false

    async save() {
        if(!await this.$validate('formValidate')) {
			return
		}
        this.loading = true
        let {code, data} =  await StationDetailApi.saveStationSettings({
            device_id: this.currentStation.id,
            device_name: this.currentStation.name,
            alarm_user_info: this.formData.userIds.length > 0 ? this.formData.userIds.map(i=> {
                let user:any = (this.$refs.entitySelect as EntitySelect).getSourceData().find(sub=> i=== sub.id);
                if(user !==undefined && user !== ''){
                    return {
                        user_id: user.id, user_name: user.real_name, mobile: user.mobile
                    }
                }
            }): [],
            alarm_threshold_value: this.rowData.map(i=> ({component_id: i.component_id, alarm_ceiling: i.alarm_ceiling, alarm_floor: i.alarm_floor,
                device_info: i.device_info, manufacturer_name: i.manufacturer_name, type: i.type,device_code: i.device_code,
                range_s: i.range_s, check_standard: i.check_standard, check_span: i.check_span, check_zero: i.check_zero})),
            devops_personnel: this.formData.people,
            devops_mobile	: this.formData.contact,
            refresh_cycle   : this.formData.refresh_cycle
        })
        this.loading = false
        if(code === 0) {
            Toast.success('保存成功')
        }

    }
    /**
     * 查询上下线
     */
    async searchComponents() {
        let {code, data} = await StationDetailApi.searchStationWarnSettings(this.id)
        if(code === 0) {
            this.rowData = data
        }
    }
    /**
     * 查询报警人员
    */
    async searchAlarmPerson() {
        let {code, data} = await StationDetailApi.searchAlarmPerson(this.id)
        if(code === 0) {
            this.formData.userIds = data.map(i=> i.user_id)
        }
    }
    /*
     查询最新一次运维信息
    */
    async searchNewOperationalTime(){
        let {code, data} = await StationDetailApi.searchNewOperationalTime(this.id)
        if (code === 0) {
           this.formData.newOpsTime = data.new_ops_time
           this.formData.opsCause = data.ops_cause
           this.formData.opsName = data.ops_name
           this.formData.opsPeriod = data.ops_period
           this.formData.timeRemaining = data.time_remaining
        }
        if(this.formData.newOpsTime != undefined){
            this.isShowOpsInfo = true;
        }else{
            this.isShowOpsInfo = false;
        }
    }
    
    /**
     查询报警管理刷新周期
     */
    async searchRefreshCycle() {
        let {code, data} = await StationDetailApi.searchRefreshCycle(this.id)
        if(code === 0) {
            this.formData.refresh_cycle = data["refresh_cycle"]
        }
    }


    async setFormData() {
        (this.$refs.formValidate as any).resetFields()
        this.searchDevops()
        this.searchComponents()
        this.searchAlarmPerson()
        this.searchNewOperationalTime()
        this.searchRefreshCycle()
    }

    mounted() {
        this.id = +this.$route.query.id;
        this.mn = this.$route.query.mn;
        this.setFormData()
        Bus.$on(Events.StationChange, this.stationChange);   
    }
    /**
     * 查询运维人员
     */
    async searchDevops() {
        let {code, data} = await StationListApi.searchDeviceList({mn: this.mn})
        if(code === 0) {
            this.formData.contact = data.data_info[0].devops_mobile
            this.formData.people = data.data_info[0].devops_personnel
        }
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.id = data.id;
        this.mn = data.mn;
        this.setFormData()
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
    }


    render(h) {
        return (
            <div class={bem()}>
                <i-form ref="formValidate"  labelWidth={100} model={this.formData} >
					<form-item label="运维人员"  prop="people" style="display: inline-block;width: 280px;margin-bottom: 5px;" >
						<Input v-model={this.formData.people} placeholder="请输入运维人员"></Input>
					</form-item>
					<form-item label="联系方式"  prop="contact" style="display: inline-block;width: 280px;margin-bottom: 5px;" >
						<Input v-model={this.formData.contact} placeholder="请输入联系方式"></Input>
					</form-item>
					<form-item label="报警通知人员" prop="userIds" style="display: inline-block;width: 280px;margin-bottom: 5px;"  type='array'>
						<EntitySelect ref="entitySelect" type={EnumEntity.User.getId()} v-model={this.formData.userIds} multiple ></EntitySelect>
					</form-item>
                    <form-item label="报警刷新周期" prop="refresh_cycle" style="display: inline-block;width: 280px;margin-bottom: 5px;" type="number">
                        <InputNumber
                            class="wqms-input-number"
                            min={1}
                            precision={1}
                            v-model={this.formData.refresh_cycle}
                            placeholder="请输入"
                        />
                    </form-item>
                    <form-item v-if={!this.isShowOpsInfo} label="暂无运维信息:"  prop="newOpsTime" style="display: inline-block;margin-bottom: 5px;">
						{/*<Input v-model={this.formData.newOpsTime} disabled></Input>*/}
                        {this.formData.newOpsTime}
					</form-item>
                    <form-item v-if={this.isShowOpsInfo} label="最新运维时间:"  prop="newOpsTime" style="display: inline-block;margin-bottom: 5px;">
						{/*<Input v-model={this.formData.newOpsTime} disabled></Input>*/}
                        {this.formData.newOpsTime}
					</form-item>
                    <form-item v-if={this.isShowOpsInfo} label="运维人员:"  prop="opsName" style="display: inline-block;margin-bottom: 5px;">
                        {this.formData.opsName}
					</form-item>
                    <form-item v-if={this.isShowOpsInfo} label="运维内容:"  prop="opsCause" style="display: inline-block;margin-bottom: 5px;">
                        {this.formData.opsCause}
					</form-item>
                    <form-item v-if={this.isShowOpsInfo} label="运维周期"  prop="opsPeriod" style="display: inline-block;margin-bottom: 5px;">
                        {this.formData.opsPeriod}天
					</form-item>
                    <form-item v-if={this.isShowOpsInfo} label="剩余运维时间"  prop="timeRemaining" style="display: inline-block;margin-bottom: 5px;">
                        {this.formData.timeRemaining}
					</form-item>
                    <Button class={createNamespace('ml10')} loading={this.loading} type="primary" on-click={this.save.bind(this)}>保存</Button>
				</i-form>
                <AgGridVueCustomTsx
                    ref="ag"
                    style="flex: 1"
                    gridOptions={this.gridOptions}
                    columnDefs={this.columnDefs}
                    rowData={this.rowData}
                    enableServerSideSorting={false}
                    checkBoxShow={false}
                    pageShow={false}
                />
            </div>
        );
    }
}
